import React from 'react'
import { shopItems } from "../../../mock/shop"
import { Section } from "../../ui"
// import '../../../assets/images/nft_1.png'
// import '../../../assets/images/nft_2.png'
// import '../../../assets/images/nft_3.png'
// import '../../../assets/images/nft_4.png'
// import '../../../assets/images/nft_5.png'
// import '../../../assets/images/nft_6.png'
// import '../../../assets/images/nft_7.png'
// import '../../../assets/images/nft_8.png'
import './shop.scss'
const BN = require("bn.js");

const ShopNFTSection = () => {

    const mintNFT = async ({number, media}) => {
        await window.contract.nft_mint(
          {
            token_id: `${window.accountId}-${number}`,
            metadata: {
              title: "My Non Fungible Team Token",
              description: `Token ${number}`,
              media
            },
            receiver_id: window.accountId,
          },
          300000000000000, // attached GAS (optional)
          new BN("26000000000000000000000000")
        );
      };

    return (
        <Section>
            <div className="shop">
                <div className="shop-info_block">
                    <h6 className="name">Synopsis</h6>
                    <p className="description">In a near future, climate-change ridden Europe has been overgrown by a marigold endemic; its yellow dust dyeing the skin of humans and mutating species. Within this world, patriarchy and oppression have returned to become an ominpresent normal. Through its dystopic world-setting, ‘Alien in Marigolds’ tells the story of illegal immigrant ALEXA, an involuntary maid working for affluent households, whose encounter with an alien lifeform will teleport her into new, mind-bending worlds. Little does she know that THEY are watching.</p>
                </div>
                <ul className="shop-list">
                    {
                        shopItems.map(({ number, price, media }) => (
                            <li className="item" key={number}>
                                <img className='item-img' src={media}/>
                                <div className="item-content_container">
                                    <div>
                                        <h5 className="item-number">{number}</h5>
                                        <p className="item-price">{`List price: ${price}`}</p>
                                    </div>
                                    <button className="get_it_btn" onClick={() => mintNFT({number, media})}>Get it</button>
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Section>
    )
}

export default ShopNFTSection
